"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthRoutes = void 0;
var AuthRoutes;
(function (AuthRoutes) {
    AuthRoutes["BasePrefix"] = "auth";
    AuthRoutes["Login"] = "login";
    AuthRoutes["LoginActiveDirectory"] = "login/active-directory";
    AuthRoutes["FirstLogin"] = "login/first";
    AuthRoutes["PasswordRecovery"] = "password/recovery";
    AuthRoutes["ResetPassword"] = "password/reset";
    AuthRoutes["RefreshToken"] = "token/refresh";
    AuthRoutes["ValidResetPasswordToken"] = "token/valid/password/reset";
    AuthRoutes["ValidCompleteRegistrationToken"] = "token/valid/complete-registration";
})(AuthRoutes = exports.AuthRoutes || (exports.AuthRoutes = {}));
